<template> 
    <ul class="excavate-page">
        <li class="page-list" v-for="(item,index) in pageList" :key="index">
            <p class="list-title" @click="title_click(item)">{{item.title}}</p>
            <div class="list-info">
                <div class="info-pic">
                    <img :src="item.url" alt="">
                </div>
                <div class="info-text">{{item.text}}</div>
            </div>
        </li>
    </ul> 
</template>

<script>
import excavateData from './comps/excavateData.js'
export default {
    data () {
        return {
            pageList:excavateData.pageList
        }
    },
    methods: {
        title_click(item){
            this.$emit('leftNavTab',item.type)
        },
    }
}
</script>

<style>

</style>